export { default as default } from './Tab';
